export async function fetchServerStatus(signal?: AbortSignal): Promise<{status: 'online' | 'offline'}> {
  const res = await fetch('/api/server-health', { signal });
  if (!res.ok) throw new Error('Failed to fetch server status');
  const data = await res.json();
  return data;
}
